import API from "../../../utils/api";

export const getOrderConditionsApi = async (filters) => {
  const response = await API.get("settings/order-condition", { params: filters });
  return { response };
};

export const addOrderConditionsApi = async (data) => {
  const response = await API.post("settings/order-condition", data);
  return { response };
};

export const updateOrderConditionsApi = async (data, id) => {
  const response = await API.put(`settings/order-condition/${id}`, data);
  return { response };
};

export const deleteOrderConditionsApi = async (id) => {
  const response = await API.delete(`settings/order-condition/${id}`);
  return { response };
};
